import { get } from 'lodash'
import { SUB_FORM_PROPS, FIELD_PROPS } from './constants'
import FieldValues from './SubFormFieldValues'

export default class SubForm {
  #fieldGetter
  #fieldPathMap
  #subFormName
  #subForm

  constructor(fieldGetter, fieldPathMap, subFormName) {
    this.#fieldGetter = fieldGetter
    this.#fieldPathMap = fieldPathMap
    this.#subFormName = subFormName
    this.#subForm = this.#getSubForm()

    this.rows = this.#getRows()
    this.items = this.#getItems()
    this.proto = this.#getProto()
    this.id = this.#getId()
    this.flatRows = this.#getFlatRows()
  }

  field(name, property = FIELD_PROPS.VALUE) {
    const values = property === FIELD_PROPS.VALUE ? new FieldValues() : []

    for (const row of this.flatRows) {
      const value = get(row, [name, property])
      values.push(value)
    }

    return values
  }

  addRow(row) {
    const newRow = { items: [] }
    const items = structuredClone(this.proto)

    for (const item of items) {
      item.value = row[item.name]
      newRow.items.push(item)
    }

    this.rows.push(newRow)
  }

  #getRows() {
    return get(this.#subForm, SUB_FORM_PROPS.ROWS)
  }

  #getFlatRows() {
    return this.rows.map(({ items }) => {
      const row = {}
      for (const item of items) {
        row[item.name] = item
      }
      return row
    })
  }

  #getItems() {
    return get(this.#subForm, SUB_FORM_PROPS.ITEMS)
  }

  #getProto() {
    const fieldPath = this.#fieldPathMap[this.#subFormName]
    const subFormStructure = this.#fieldGetter(fieldPath)
    return structuredClone(get(subFormStructure, SUB_FORM_PROPS.PROTO))
  }

  #getId() {
    return get(this.#subForm, SUB_FORM_PROPS.ID)
  }

  #getSubForm() {
    const fieldPath = this.#fieldPathMap[this.#subFormName]
    const subFormStructure = this.#fieldGetter(fieldPath)

    return structuredClone(get(subFormStructure, SUB_FORM_PROPS.SUB_FORM))
  }
}
